import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';

// Renders a floating "Chat on WhatsApp" bubble on public pages.
// Reads the number from public site-settings — hides itself if not configured.
// Uses wa.me click-to-chat — completely free, no integration required.
const WhatsAppFloat = () => {
  const [num, setNum] = useState('');

  useEffect(() => {
    api.get('/content/site-settings')
      .then(({ data }) => {
        const raw = (data?.whatsapp_number || '').replace(/\D/g, '');
        if (raw) setNum(raw);
      })
      .catch(() => {});
  }, []);

  if (!num) return null;
  const msg = encodeURIComponent("Hi Saans Ayurved, I'd like to know more.");
  const href = `https://wa.me/${num}?text=${msg}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer noopener"
      aria-label="Chat with Saans Ayurved on WhatsApp"
      data-testid="whatsapp-float"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-105 transition-transform"
    >
      <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden="true">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.031-.966-.273-.099-.471-.148-.67.15-.197.296-.767.966-.94 1.164-.173.198-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
        <path d="M20.52 3.449C18.24 1.19 15.24 0 12.045 0 5.463 0 .104 5.334.101 11.891c0 2.096.549 4.142 1.595 5.945L0 24l6.335-1.652c1.746.943 3.71 1.444 5.71 1.447h.006c6.585 0 11.946-5.336 11.949-11.896 0-3.176-1.24-6.165-3.481-8.413zm-8.475 18.297h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.98.999-3.648-.235-.375A9.86 9.86 0 012.101 11.893c.001-5.462 4.462-9.905 9.95-9.905 2.658.001 5.156 1.036 7.033 2.913a9.856 9.856 0 012.913 7.007c-.003 5.463-4.464 9.906-9.949 9.906z"/>
      </svg>
    </a>
  );
};

export default WhatsAppFloat;
